import { memo } from 'react';
import { Box } from '@bonanza-social/moonlight';

import { LevelHeaderItem } from '@bonanza-social/levels';
import { StatusHeaderItem } from '@bonanza-social/status';
import { InboxHeaderItem } from '@bonanza-social/inbox';
import MainHeaderCTA from './MainHeaderCTA';
import LinkedBonanzaLogo from '../../LinkedBonanzaLogo';
import CoinBalanceHeaderItem from '../../CoinBalanceHeaderItem/CoinBalanceHeaderItem';

function MobileMainHeader() {
  return (
    <Box alignItems="center" gap="space-200" padding="space-400">
      <Box centerContent>
        <LinkedBonanzaLogo />
      </Box>
      <Box
        flexDirection="row"
        justifyContent="flex-start"
        width="100%"
        gap="space-200"
      >
        <Box flex={1}>
          <CoinBalanceHeaderItem />
        </Box>
        <Box width="60%">
          <MainHeaderCTA />
        </Box>
      </Box>
      <Box
        flexDirection="row"
        justifyContent="space-between"
        width="100%"
        gap="space-200"
      >
        <LevelHeaderItem flex={1} />
        <StatusHeaderItem flex={1} />
        <InboxHeaderItem />
      </Box>
    </Box>
  );
}

export default memo(MobileMainHeader);
